import axios from "axios";
import { API_URL,SERVER_URL } from '../Constants';

class DashboardService{
    getCompleteCompanyStats(accessToken) {
        return axios.get(`${API_URL}getDashboardCompleteStatistics/`,{headers:{'Authorization':accessToken}});
    };

    createCompleteCompanyStats(accessToken) {
        return axios.get(`${API_URL}createDashboardCompleteStatistics/`,{headers:{'Authorization':accessToken}});
    };

    downloadFile(accessToken,fileName){
        window.open(`${SERVER_URL}${fileName}`, {headers:{'Authorization':accessToken}})
    };

    createOverUnderDocument(accessToken) {
        return axios.get(`${API_URL}createOverUnderDocument/`,{headers:{'Authorization':accessToken}});
    };

    getProcoreLaborData(accessToken) {
        return axios.get(`${API_URL}/procoreResources`, { headers: { 'Authorization': accessToken } });
    };

    refreshLaborData(accessToken){
        return axios.get(`${API_URL}/refreshResourceData`, { headers: { 'Authorization': accessToken } });
    };

    getFieldServiceLaborData(accessToken) {
        return axios.get(`${API_URL}getFSAppointments/`,{headers:{'Authorization':accessToken}});
    };

    getServiceTechnicians(accessToken) {
        return axios.get(`${API_URL}getTechnicians/`,{headers:{'Authorization':accessToken}});
    };

    generateLaborEquipmentReport(accessToken) {
        return axios.get(`${API_URL}generateLaborEquipmentReport/`,{headers:{'Authorization':accessToken}});
    };

    getIgnoredTitles(accessToken) {
        return axios.get(`${API_URL}getIgnoredTitles/`,{headers:{'Authorization':accessToken}});
    };

    updateIgnoredTitles(accessToken, titlesObject) {
        return axios.post(`${API_URL}updateIgnoredTitles/`, titlesObject, { headers: { 'Authorization': accessToken } });
    };

    getLEViews(accessToken) {
        return axios.get(`${API_URL}getLaborEquipmentViews/`,{headers:{'Authorization':accessToken}});
    };

    createLEViews(accessToken, viewsObject) {
        return axios.post(`${API_URL}createLaborEquipmentView/`, viewsObject, { headers: { 'Authorization': accessToken } });
    };

    updateLEViews(accessToken, viewsObject) {
        return axios.post(`${API_URL}updateLaborEquipmentView/`, viewsObject, { headers: { 'Authorization': accessToken } });
    };

    deleteLEView(accessToken, viewId) {
        return axios.delete(`${API_URL}deleteLaborEquipmentView/${viewId}/`, { headers: { 'Authorization': accessToken } });
    };


};


DashboardService = new DashboardService();
export default DashboardService;